import { of } from 'rxjs/observable/of';

import { logoutAction, errorAction } from '../../reducers/actions';

/**
  Code to run when an API call fails
  @function retryAuthentication
  @param {Observable} action$
  @returns {Observable}
*/
export const retryAuthentication = (action$, inputSource) => (error, source) => {
  if (error.status === 401 && error.response.error === 'invalid_token') {
    return of(logoutAction());
  } else {
    return of(errorAction(error, inputSource));
  }
};



// WEBPACK FOOTER //
// ./src/utils/epics/retryAuthentication.js